<template>
  <div class="my-3">
    <hr class="text-dark">
    <p>نکته: اطلاعات را به صورت زیر وارد کنید که فیلتر پذیر باشند.</p>
    <p>مثال: سامسونگ:s3 </p>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
      </div>
    </div>
    <div class="d-block">
      <b-icon class="bg-primary p-1 rounded-pill h3 text-white  my-2" icon="plus" @click="addOption()"/>
      <b-icon class="bg-danger p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash" @click="deleteQuestion()"/>
    </div>

    <div class="form-group">
      <input type="checkbox" :id="`select-box-with-filter-input${item.id}`" v-model="item['disable_search']">
      <label :for="`select-box-with-filter-input${item.id}`" class="mx-1">غیرفعال کردن سرچ</label>
    </div>

    <input type="text" class=" form-control" v-model="item.title">

    <div class="form-check form-check-inline" v-for="(option,index) in item.options">
      <label class="form-check-label mx-2" :for="`${generateHashComputed}_${index}`"> {{ index + 1 }}</label>
      <input type="text" class="m-2 form-control" v-model="option.label">
      <b-icon class="bg-danger p-1 rounded-pill h3 text-white d-block my-2" icon="trash" @click="deletedOption(index)"/>
    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "SelectBoxWithFilterInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    addOption() {
      let countOptions = this.item.options.length
      this.item.options.push({
        "id": (countOptions + 1),
        "label": "ایتم",
        "value": 0
      })
      this.$forceUpdate()
    },
    deletedOption(index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.item.options.splice(index, 1)
        this.$forceUpdate()
      }
    },
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  },
}
</script>


<style scoped>

</style>